import React from "react";
import styled, { css } from "styled-components";

import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import workerSrc from "../../assets/images/worker-mass-produce.png";
import {
  Paragraph,
  SlideContainer,
  Title,
} from "./OurCommitment.styles";



const StyledTitle = styled(Title)`
  font-size: 26px;
  font-family: "noto-sans", sans-serif;
`;

const StyledParagraph = styled(Paragraph)`
  width: 100%;
`;

const OutCommitmentSlide6 = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <SlideContainer style={{padding:"0px 20px"}}>
      <StyledTitle theme={theme}>
        {t("We Don't Mass Produce, We Make To Order")}
      </StyledTitle>
      <StyledParagraph theme={theme}>
        {t(
          "Your evrbed isn't built until you place your order. That means you get the custom mattress you want, and we don't produce more mattresses than needed, eliminating excess waste."
        )}
      </StyledParagraph>
      <StyledParagraph theme={theme}>
        {t(
          "The best part? We make them right here in Canada, employing skilled artisans and reducing the need for overseas shipping. We source the majority of our materials from local vendors, and continuously work with our suppliers to ensure supply chain and material sustainability."
        )}
      </StyledParagraph>
      <Worker />
    </SlideContainer>
  );
};

const Worker = styled.img.attrs({
  src: workerSrc,
})`
  padding-top: 15px;
  width: 100%;
`;

export default OutCommitmentSlide6;
